// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f487139d","453":"9be83081","455":"1ce5cb3e","977":"4ffd7e06"}[chunkId] + ".chunk.js";
};